export default "__VITE_ASSET__BHs4yaBe__"